<div *ngIf="!isOpened">
  <div class="row px-1 container-style px-2 py-1">
    <div class="only-button d-flex justify-content-end">
      <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
        [severity]="'success'" [variant]="undefined" (onClick)="openModalCity()"></app-custom-button>
      <app-custom-modal #cityModal [label]="'Captura Ciudad'" [header]="'Captura Ciudad'"
        [children]="componentRegisterCity" [inputs$]="inputsForCity$" [width]="'30vw'" [output$]="inputsForCity$"
        hidden></app-custom-modal>
    </div>
  </div>
  <div class="container-style mt-2">
    <app-custom-table [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
      [previousFilters]="filters" [filterPersistentKey]="url" (onRecoverData)="getAllCitiesWithPagination()"
      (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>